import { StatLocation } from '../../../../../common/models/statistics/stat-data';

export class StatTableModel {
  annualCO2Reduction: string;
  investment: string;
  investmentReturn: string;
  systemCapacity: string;
  source: string | null;
  time: string | null;
  userContact: string | null;
  omm: string | null;
  tariffGroup: string | null;
  lat: string;
  lng: string;

  static fromStatData(data: StatLocation): StatTableModel[] {
    return data.statistics.map(stat => ({
      annualCO2Reduction: stat.annualCO2Reduction,
      investment: stat.investment,
      investmentReturn: stat.investmentReturn,
      systemCapacity: stat.systemCapacity,
      source: stat.source,
      time: stat.time,
      userContact: stat.userContact,
      omm: stat.omm,
      tariffGroup: stat.tariffGroup,
      lat: data.lat,
      lng: data.lng,
    }));
  }
}
